module.exports = "static/assets/679ce05ac8c35bbf83f596e895ab711b.svg";